import logo from './logo.svg';
import './App.css';
import fp from './utils/fingerprint';
// import './utils/origin-fp';
import {useEffect} from "react";


function App() {
  useEffect(() => {
    console.log('canvasFp', fp.canvasFp);
    console.log('feSign', fp.feSign);
    console.log('webglFp', fp.webglFp);
    console.log('screenInfo', fp.screenInfo);
  }, []);
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
